export default __webpack_public_path__ + "static/media/trash-outline.1c363fbd.svg";